// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.paging-container {
    display: flex;
    gap: .8rem;
}

.paging-tile {
    border: 2px solid #26a69a;
    padding: .5rem 1rem;
    background-color: rgba(240, 255, 255, 0.4);
    cursor: pointer;
    border-radius: 5px;
    -webkit-touch-callout: none;
    -webkit-user-select: none; 
    -khtml-user-select: none;
    -moz-user-select: none; 
    -ms-user-select: none; 
    user-select: none;
}

.paging-tile.selected-tile {
    background-color: rgba(240, 255, 255, 0.8);
    font-weight: bolder;
    border: 3px solid #26a69a;
    text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/paging/Paging.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,0CAA0C;IAC1C,eAAe;IACf,kBAAkB;IAClB,2BAA2B;IAC3B,yBAAyB;IACzB,wBAAwB;IACxB,sBAAsB;IACtB,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,0CAA0C;IAC1C,mBAAmB;IACnB,yBAAyB;IACzB,0BAA0B;AAC9B","sourcesContent":[".paging-container {\r\n    display: flex;\r\n    gap: .8rem;\r\n}\r\n\r\n.paging-tile {\r\n    border: 2px solid #26a69a;\r\n    padding: .5rem 1rem;\r\n    background-color: rgba(240, 255, 255, 0.4);\r\n    cursor: pointer;\r\n    border-radius: 5px;\r\n    -webkit-touch-callout: none;\r\n    -webkit-user-select: none; \r\n    -khtml-user-select: none;\r\n    -moz-user-select: none; \r\n    -ms-user-select: none; \r\n    user-select: none;\r\n}\r\n\r\n.paging-tile.selected-tile {\r\n    background-color: rgba(240, 255, 255, 0.8);\r\n    font-weight: bolder;\r\n    border: 3px solid #26a69a;\r\n    text-decoration: underline;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
